import { Plano } from './../models/plano';
import { Notificacao } from './../models/notificacao';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { LocalStorageService } from './local-storage.service';
import { AutenticacaoService } from './autenticacao.service';
import { environment } from './../../environments/environment';
import { Observable } from "rxjs/Rx";

@Injectable()
export class PlanoService {

  private API_URL: string = environment.apiUrl;
  
  constructor
  (
    private http: Http
  )
  { }

  public obterPlanos(): Observable<Array<Plano>>{
    return this.http.get(`${this.API_URL}planos`)
      .map(response => response.json(), error => error.json());
  }

  public cadastrarPlano(plano: Plano) : Observable<Plano> {
    return this.http.post(`${this.API_URL}planos/salvar`, plano)
                .map(
                  response => response.json(),
                  error => error.json()
                );
  }

  public excluir(idsPlanos: Array<number>): Observable<Plano> {

    return this.http.put(`${this.API_URL}planos/excluir`, idsPlanos)
            .map(
              response => response.json(),
              error => error.json()
            );
  }

  public obterPorTenant(itemOrdenar: string, ordenacao: string, itensPorPagina: number, pagina: number, termo?: string): Observable<Array<Plano>> {
    return this.http.get(`${this.API_URL}planos/tenant/`, { search: { itemOrdenar: itemOrdenar, ordenacao: ordenacao, itensPorPagina: itensPorPagina, pagina: pagina, termo: termo } })
        .map(
          response => response.json(),
          error => error.json()
        );
  }

  public obterQuantidadePaginaPorTenant(itensPorPagina: number, termo?: string): Observable<number> {
    return this.http.get(`${this.API_URL}planos/tenant/quantidade`, { search: { itensPorPagina: itensPorPagina, termo: termo } })
        .map(
          response => response.json(),
          error => error.json()
        );
}
}



// WEBPACK FOOTER //
// ./src/app/app-services/plano.service.ts